import channelLogic from "./Channel/Logic/";
import userLogic from "./User/Logic/";

export default [...channelLogic, ...userLogic];
